var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClubnoeshort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "356.000000pt",
    height: "360.000000pt",
    viewBox: "0 0 356.000000 360.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,360.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1125 2479 c-220 -33 -406 -143 -510 -299 -155 -233 -168 -604 -30 -835 134 -223 389 -345 724 -345 240 0 413 50 453 130 23 46 27 310 5 310 -9 0 -19 -22 -26 -57 -28 -130 -83 -210 -178 -260 -74 -39 -141 -53 -256 -53 -260 1 -447 110 -551 321 -59 121 -78 216 -78 384 0 221 46 363 157 483 64 70 175 131 273 151 80 17 258 14 322 -5 30 -9 69 -17 85 -17 27 -2 30 1 30 27 0 20 -9 35 -28 49 -24 19 -43 21 -180 23 -83 2 -179 -1 -212 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1727 2483 c-4 -3 -7 -163 -7 -355 0 -339 1 -349 21 -369 18 -18 23 -19 42 -6 21 14 22 20 22 212 l0 198 249 -254 c337 -344 596 -617 735 -776 64 -73 121 -133 127 -133 8 0 13 112 18 398 9 566 23 943 36 977 16 42 47 73 81 80 16 4 29 12 29 18 0 9 -54 12 -203 12 -211 0 -241 -7 -148 -35 63 -19 91 -46 103 -101 9 -42 24 -938 17 -988 -4 -21 -55 28 -381 363 -208 213 -455 472 -550 576 -95 105 -175 190 -179 190 -3 0 -9 -3 -12 -7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClubnoeshort);
export default __webpack_public_path__ + "static/media/club noe short.2785f6777de07674b92758ae2931691d.svg";
export { ForwardRef as ReactComponent };